import { isToday, isTomorrow, differenceInCalendarWeeks } from 'date-fns'
import { computed, toValue } from 'vue'

export function useDayEstimate(date, t) {

  return computed(() => {
    const day = toValue(date)

    const weekDiff = differenceInCalendarWeeks(day, new Date())

    let type
    if (isToday(day)) {
      type = 'today'
    } else if (isTomorrow(day)) {
      type = 'tomorrow'
    } else if (weekDiff === 0) {
      type = 'this_week'
    } else if (weekDiff === 1) {
      type = 'next_week'
    } else if (weekDiff > 1) {
      type = 'in_number_of_weeks'
    }

    return t(`day_estimate.${type}`, { number: weekDiff })
  })
}
